export enum DriverDefaults {
  NO_DRIVER_IN_VEHICLE = 'No driver in the vehicle',
  DRIVER_NOT_ON_POLICY = 'Driver is not on policy',
  VEHICLE_NOT_ON_POLICY = 'Vehicle is not on policy'
}
